import React, { Component } from 'react'
import './index.less';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { Heart } from 'src-features/commonUI/arrow'
import {localStore} from 'src-common/utils';

const favorite = (id) => () => {
    let oldData = localStore.getStore('interact_data');
    oldData.interact_data.street_id_list.push(id);
    localStore.setStore('interact_data', oldData);
}

class ImageHeader extends Component {
    render() {
        return (
            <div className="theme-img-container">
                <img className="theme-image" src={this.props.data} onLoad={this.props.getElementSize}/>
                {_.isArray(this.props.points) && !_.isEmpty(this.props.containerSize) && 
                    <BlinkDotCover 
                        image={this.props.image} 
                        points={this.props.points} 
                        containerSize={this.props.containerSize}
                    />
                }
            </div>
        )
    }
}

class BlinkDotCover extends Component {

    getConvertedLocation = (points, parentSize, imgNaturalSize) => {

        return points.map(point => ({
            x: Math.round((point.point_loc.x/imgNaturalSize.width) * parentSize.elementWidth),
            y: Math.round((point.point_loc.y/imgNaturalSize.height) * parentSize.elementHeight),
            similar_items: point.similar_items,
        }))
    }
    render() {
        const {width, height} = this.props.image;
        const {elementWidth, elementHeight} = this.props.containerSize;
        let points = this.getConvertedLocation(this.props.points, {elementWidth, elementHeight}, {width, height});

        return (
            <div className="blink-dot-cover">
                {
                   points.map((position, index) => <BlinkDot position={position} key={index} />)
                }
            </div>
        )
    }
}
class BlinkDot extends Component {
    render() {
        const {x, y, similar_items} = this.props.position;
        return (
            <span style={{
                position: 'absolute',
                top: `${y-12}px`,
                left: `${x-12}px`,
                width: '24px',
                height: '24px',
                // pointerEvents: 'none'
              }}>
              {/* <a href={`#${similar_items.category.split(' ').join('_')}`}> */}
                <span className="blink-dot" style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    backgroundColor: '#000',
                }}/>
                <span style={{
                    position: 'absolute',
                    top: '8px',
                    left: '8px',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                }}/>
                <span className="dot-tooltips">
                    <span>{similar_items.num}</span>{` ${similar_items.desc}`}
                    <span className='dot-angle' />
                </span>
                {/* </a> */}
              </span>
        )
    }
}

class ThemeContainer extends Component {
    state = {image: {}, points: [], elementSize: {}}
    getData = () => {
        let data = this.props.data;
        let similarPoint = data.data.street_snap.street_item_position_list.map(point => ({
            point_loc: { x: point.point_location.x, y: point.point_location.y },
            similar_items: { 
                num: point.similar_items_num, 
                desc: point.similar_items_desc, 
                redirect_url: point.redirect_url,
                category: point.category,
            }
        }))
        this.setState({
            image: data.data.street_snap.image,
            points: similarPoint
        });
    }

    componentDidMount() {
        this.getData();
    }

    getElementSize = ({target:img}) => {
        this.setState({
            elementSize: {
                elementWidth: img.clientWidth,
                elementHeight: img.clientHeight,
            }
        })
    }
    render() {
        const {data = {}} = this.props.data;
        return (
            <div className="theme-container">
                <div className="banner">
                    <div className="avatar">
                        <Link className="avatar-circle" to={`/influencer/${data.influencer_id}`}><img src={data.avatar_url}/></Link>
                        <span>{data.influencer_name}</span>
                    </div>
                    <div className="action"><Heart color="#000000" size="26px" action={favorite(this.props.streetID)}/></div>
                </div>
                <ImageHeader 
                    data={this.state.image.image_url} 
                    getElementSize={this.getElementSize}
                    image={this.state.image} 
                    points={this.state.points} 
                    containerSize={this.state.elementSize}
                />
                
            </div>
        )
    }
}

export default ThemeContainer;


// WEBPACK FOOTER //
// ./src/features/streetSnap/streetInfluencer/component/theme_header/header_img.jsx